( function () {
   
    'use strict';

    ( function ( $ ) {
        $('.hero-slider-banner-video').slick({
            dots:true,
            // infinite: true,
            speed: 900,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            autoplaySpeed: 8000,
            arrows:false,
            variableWidth: false,
            fade:true,
            cssEase: 'ease-in-out',
            touchThreshold: 100,
            responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:1,
                    infinite: true,
                }
            },
            {
                breakpoint:767,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:1,
                }
            }
            ]
        });
             
        
    } )( jQuery );
} )();

